import * as _ from 'lodash'
/* tslint:disable no-any */
export const toCamelCase = (obj: any): any => {
  if (_.isPlainObject(obj) || _.isArray(obj)) {
    const mappedObject = _.isArray(obj) ? [] : {};

    _.forOwn(obj, (val, key) => {
      if (_.isArray(obj)) {
        (mappedObject as any[]).push(toCamelCase(val));
      } else {
        mappedObject[_.camelCase(key)] = _.isArray(val) ? toCamelCase(val) : val;
      }
    });

    return mappedObject;
  } else {
    return obj;
  }
};
export const toCamelCaseMiddleware: any = (store: any): any => (next: any): any => (action: any): any => {
  if (!_.isFunction(action) && !!action.type && action.type[0] !== "@" && _.isObject(action.payload)) {
    action.payload = toCamelCase(action.payload);
  }
  return next(action);
};
/* tslint:enable no-any */

export default toCamelCaseMiddleware;
